'use client';

import { createContext } from 'react';

export const FunnelTrackingContext = createContext(true);
